import { useLocation } from "react-router-dom";
import React from "react";
import queryString from "query-string";

export const useQueryParams = () => {
  const { search } = useLocation();

  return React.useMemo(() => queryString.parse(search), [search]);
};
